var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewBlockMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 194,
    viewBox: "0 0 307 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4993 11.679H267.148L303.174 68.5235V163.975L286.942 189.593H7.90667",
    stroke: "#1DA88F",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9378 6.64893H263.595L299.612 63.4935V158.945L283.38 184.563H4.35386",
    stroke: "#1DA88F",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5335 9H270.015L306 65.8764V161.381L289.782 187H11",
    stroke: "#1DA88F",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5315 6H269.007L305 64.1596V161.793L288.783 188H10",
    stroke: "#1DA88F",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5578 1.00024H265.207L301.224 62.2154V164.978L284.992 192.562H5.96519",
    stroke: "#1DA88F",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5315 4H263.007L299 63.428V163.217L282.783 190H4",
    stroke: "#05F2C7",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5833 6.64868H259.241L295.258 63.4932V158.944L279.026 184.563H-0.000631341",
    stroke: "#05F2C7",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7624 6H265.893L302 63.835V160.949L285.727 187H6.00001",
    stroke: "#05F2C7",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5315 6H264.007L300 63.84V160.937L283.783 187H5",
    stroke: "#05F2C7",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2033 1H260.852L296.869 62.2151V164.978L280.637 192.562H1.6107",
    stroke: "#05F2C7",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewBlockMobile);
export default __webpack_public_path__ + "static/media/review_block-mobile.f450d79491d1e325b2f64fe04a00785b.svg";
export { ForwardRef as ReactComponent };